import { styled } from "sharedUI/styles";

export const AppPlanPreviewContainer = styled.div<{ locked: boolean }>`
    position: relative;
    width: 290px;
    background-color: ${p => p.theme.upgradeModal.planPreview.background};
    border-radius: 9px;
    border: 1px solid ${p => p.theme.upgradeModal.border};

    > .toggle {
        position: absolute;
        top: 11px;
        right: 11px;
    }

    > .info {
        padding: 16px;

        > .title {
            font-weight: 800;
            font-size: 18px;
            color: ${p => p.theme.textDark};
            margin-bottom: 10px;
        }

        > .line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0px;
            font-size: 14px;
            width: 100%;

            &.no-expand {
                justify-content: flex-start;
            }

            &.sm-padding {
                padding: 4px 0px;
            }

            &.no-padding {
                padding: 0px;
            }

            &.private-users-title {
                height: 16px;
                margin-bottom: 4px;
            }

            > .line-title {
                text-transform: uppercase;
                font-size: 12px;
                font-weight: 700;

                &.private-users {
                    text-align: right;
                    flex-grow: 1;
                    color: ${p => (p.locked ? p.theme.textDark : p.theme.textAccent)};
                }

                &.light {
                    color: ${p => p.theme.textXpale};
                }
            }

            > .line-title-sm {
                font-size: 12px;
                font-weight: 400;
                line-height: 14px;

                &.light {
                    color: ${p => p.theme.textPale};
                }
            }

            > .line-total {
                font-weight: 700;
            }

            &.line-separator {
                padding-bottom: 8px;
                border-bottom: 1px solid ${p => p.theme.upgradeModal.border};
            }

            &.line-last {
                padding-bottom: 0px;
            }

            &.contact-sales-button {
                padding: 4px 0px 8px 0px;
                width: 100%;
                a {
                    width: 100%;
                }
            }

            > .change {
                margin-left: 4px;
            }
        }
    }

    > .promo-container {
        border-top: 1px solid ${p => p.theme.upgradeModal.border};
    }
`;
